import { ItemProps } from '@snack-uikit/list';

import { NavListItem } from '@/components/static';
import { MainPageConfig } from '@/types/ssr';

import { MainPageContent } from './MainPageContent';

const makeTableOfContentConfig = (configs: MainPageConfig): ItemProps[] =>
  configs.contentConfig.map(config => {
    const hasItems = config.categories?.some(category => Boolean(category.anchor));
    return {
      content: {
        option: config.title,
        truncate: { option: 3 },
      },
      itemWrapRender: element => (
        <NavListItem itemType='TOC' hasNested={hasItems} itemLink={`#${config.anchor}`}>
          {element}
        </NavListItem>
      ),
      type: hasItems ? 'collapse' : undefined,
      id: `#${config.anchor}`,
      items: hasItems
        ? config.categories?.map(category => ({
            content: {
              option: category.title,
              truncate: { option: 3 },
            },
            id: `#${category.anchor}`,
            itemWrapRender: element => (
              <NavListItem itemType='TOC' itemLink={`#${config.anchor}`}>
                {element}
              </NavListItem>
            ),
          }))
        : [],
    };
  });

export const makeMainPageUnits = (config: MainPageConfig) => ({
  TOC: makeTableOfContentConfig(config),
  content: config.contentConfig.map(cfg => (
    <MainPageContent defaultIconName={config.defaultIcon} key={cfg.title} config={cfg} />
  )),
});
